import styled from "styled-components";

export const DropdownBtn = styled.div`
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  transition: all 0.1s ease 0s;
  appearance: none;
  border: none;
  letter-spacing: 0.5px;
  cursor: pointer;
  user-select: none;
  border-radius: 6px;

  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  text-transform: uppercase;
  color: rgb(255, 255, 255);
  background: rgba(203, 215, 255, 0.075);
  height: 28px;
  width: 30px;
  padding: 0px;
  position: relative;
  margin-left: auto;
`;
